<template>
  <b-modal class="modal modal-confirm bg-body" id="ModalFormLab" size="xl">
    <template #modal-title>
      <h4 class="mb-0 text-left">Ubah Tagihan Lab Rawat Jalan</h4>
    </template>
    <div class="container-fluid">
      <Alert
        v-if="saveFailed"
        :alert="{
          type: 'danger',
          title: 'Gagal Menyimpan Data',
          content:
            'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
        }"
      />
      <Alert
        v-if="saveSuccess"
        :alert="{
          type: 'success',
          title: 'Berhasil Menyimpan Data',
          content: 'Penyimpanan data berhasil dilakukan',
        }"
      />
      <!-- <PageContentHeader
        :data="data"
        :fromUrl="fromUrl || ''"
        :fromTab="$route.query.fromTab || ''"
      />
      <DetailTop v-if="detailTop" :detailTop="detailTop" />
      <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
        <div class="col-md-7 pr-1" v-if="detailLeftTop">
          <DetailLeft :detailLeftTop="detailLeftTop" />
        </div>
        <div class="col-md-5 pl-1" v-if="detailRightTop">
          <DetailRight :detailRightTop="detailRightTop" />
        </div>
      </div> -->
      <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
      <div class="row mt-3">
        <!-- <div class="col-md-4 px-0">
                <b-col>
                    <b-card>
                        <div class="mb-3">
                            <span class="item-label font-heading text-muted">
                                PETUGAS
                            </span>
                            <h5 class="item-content font-body">
                                {{formSet.petugas_lab}}
                            </h5>
                        </div>
                        <div>
                            <span class="item-label font-heading text-muted">
                                STATUS
                            </span>
                            <h5 class="item-content font-body">
                                {{formSet.lab_type}}
                            </h5>
                        </div>
                    </b-card>
                </b-col>
            </div> -->
        <div class="col-md-12" style="position: relative">
          <div class="d-flex flex-between mb-3">
            <h5 class="mb-2">Pemeriksaan Lab</h5>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-12">
                <div class="input-group">
                  <input
                    type="text"
                    :class="
                      'form-control form-control-lg pl-5 with-icon-left without-label ' +
                        (isError ? 'error' : '')
                    "
                    placeholder="Cari kode atau nama pemeriksaan lab"
                    @input="
                      (e) => {
                        a_lab = false;
                        s_lab = e.target.value;
                      }
                    "
                    :value="s_lab"
                    v-on:keyup.enter="() => search('lab')"
                  />
                  <i
                    class="material-symbols-outlined"
                    style="margin-top: -0.25rem"
                    >search</i
                  >
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary btn-with-icon-left"
                      @click="() => search('lab')"
                    >
                      <i class="material-symbols-outlined">search</i>
                      CARI
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SearchResult
            type=""
            @addItem="(item) => addItem(item, 'lab')"
            v-if="s_lab && a_lab"
            :loading="l_lab"
            :data="r_lab"
          />
          <table class="responsive" v-if="lab.length">
            <thead>
              <th>KODE</th>
              <th>NAMA PEMERIKSAAN LAB</th>
              <th>TARIF/BIAYA</th>
              <th>STATUS</th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="item in lab.filter((item) => !item.deleted)"
                v-bind:key="item.id + Math.random(1024)"
              >
                <td>{{ item.kode }}</td>
                <td>{{ item.nama }}</td>
                <td>{{ item.formatted_biaya }}</td>
                <td>{{ item.status || "BELUM DIBAYAR" }}</td>
                <td>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <!-- <button
                      class="btn btn-with-icon-left btn-secondary btn-sm"
                      @click="() => undoCancel('lab', item.id)"
                      v-if="item.status == 'DIBATALKAN' && item.deleted"
                    >
                      <i class="material-symbols-outlined">undo</i>
                      Kembalikan
                    </button>
                    <button
                      class="btn btn-with-icon-left btn-danger btn-sm"
                      @click="() => cancelItem('lab', item.id)"
                      v-else-if="item.status != 'DIBATALKAN'"
                    >
                      <i class="material-symbols-outlined">cancel</i>
                      Batalkan
                    </button> -->
                    <td>
                      <button
                        class="btn btn-icon btn-danger btn-sm"
                        @click="() => deleteItem('lab', item.id)"
                        v-if="item.status != 'DIBATALKAN'"
                      >
                        <i class="material-symbols-outlined">delete</i>
                      </button>
                    </td>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--/form-->
    </div>
    <template #modal-footer>
      <div class="w-100">
        <button
          class="btn btn-primary float-right"
          @click="
            () => {
              handleForm();
            }
          "
        >
          SIMPAN
        </button>
        <button
          type="button"
          class="btn btn-outline-primary mr-3 float-right"
          @click="$bvModal.hide('ModalFormLab')"
        >
          BATAL
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResult from "@/components/SearchResult.vue";
// import Navbar from "@/components/Navbar.vue";
// import Sidebar from "@/components/Sidebar.vue";
// import PageContentHeader from "@/components/PageContentHeader.vue";
// import FormRow from '@/components/FormRow.vue'
// import DetailTop from "@/components/DetailTop.vue";
// import DetailLeft from "@/components/DetailLeft.vue";
// import DetailRight from "@/components/DetailRight.vue";
import { setBayarIntro, convertToRupiah } from "@/data/helper.js";
// import { HTTP,HTTP } from "@/config.js";
import { data, tindakanForm, labForm } from "@/data/LabForm.js";
export default {
  name: "ModalFormLab",
  components: {
    // Navbar,
    // Sidebar,
    // PageContentHeader,
    // DetailTop,
    // DetailLeft,
    // DetailRight,
    Alert,
    SearchResult,
  },
  props: {
    no_rawat: String,
    id_ralan: Number,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      changed: false,
      hasCanceled: false,
      data: data,
      tindakanForm: tindakanForm,
      labForm: labForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        no_rawat: "",
        petugas_lab: "",
        lab_type: "Dewasa",
        id_petugas_lab: "",
      },
      n: 0,
      s_lab: "",
      s_doc: "",
      s_nrs: "",
      s_both: "",
      r_lab: [],
      r_doc: [],
      r_nrs: [],
      r_both: [],
      lab: [],
      doc: [],
      nrs: [],
      both: [],
      a_lab: false,
      a_doc: false,
      a_nrs: false,
      a_both: false,
      l_lab: false,
      l_doc: false,
      l_nrs: false,
      l_both: false,
      isError: false,
    };
  },
  methods: {
    showModal() {
      this.$bvModal.show("ModalFormLab");
    },
    hideModal() {
      this.$bvModal.hide("ModalFormLab");
    },
    // handleForm() {
    //   this.$emit("onSave");
    //   this.hideModal();
    // },

    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    confirmSave: function() {
      if (this.hasCanceled) {
        document.getElementById("#openModal").click();
      } else {
        this.handleForm();
      }
    },
    handleForm: async function() {
      let self = this;
      let labs =
        this.lab && this.lab.length
          ? [...this.lab]
              .filter((item) => !(item.deleted && !item.id_ralan_lab))
              .map((item) => {
                //console.log(item);
                return {
                  operation: item.deleted ? "delete" : null,
                  no_rawat: self["no_rawat"],
                  id_petugas: self.formSet["id_petugas_lab"],
                  id_periksa_lab: item.id,
                  biaya: item.biaya,
                  kategori: self.formSet["lab_type"],
                };
              })
          : [];
      //console.log(labs);
      if (labs && labs.length) {
        try {
          let resultLab = await this.$store.state.HTTP_JSON.post(
            `/ralan/pemeriksaan/lab-bulk`,
            { labs: labs }
          );
          //console.log(resultLab);
          if (!resultLab || resultLab.status != 200) {
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess();
            return;
          }
        } catch (e) {
          //console.log(e);
          this.saveFailed = true;
          this.saveSuccess = false;
          this.checkSuccess();
          return;
        }
      }
      this.checkSuccess();
    },
    handleFormOld: async function() {
      let self = this;
      self.errors = [];
      self.n = this.lab.filter(
        (item) => !(item.deleted && !item.id_ralan_lab)
      ).length;
      this.lab.forEach(async function(item) {
        if (!item.deleted) {
          if (!item.id_ralan_lab) {
            let body = `no_rawat=${self["no_rawat"]}&id_periksa_lab=${item.id}&kategori=${self.formSet.lab_type}`;
            self.saveLab(body);
          } else {
            let body = `id_periksa_lab=${item.id}`;
            self.saveLab(body, item.id_ralan_lab);
          }
        } else {
          if (item.id_ralan_lab) {
            self.deleteLab(item.id_ralan_lab);
          }
        }
      });
    },
    async saveLab(body, id) {
      try {
        if (id) {
          //console.log(body);
          // let result = await this.$store.state.HTTP.put(`ralan/pemeriksaan/lab/${id}`,body);
          //console.log(result);
          // if(result.status=='200'){
          //     this.n=this.n-1;
          //     if(this.n==0){
          //         this.checkSuccess();
          //     }
          // }
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        } else {
          let result = await this.$store.state.HTTP.post(
            `ralan/pemeriksaan/lab`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteLab(id) {
      try {
        let result = await this.$store.state.HTTP.delete(
          `ralan/pemeriksaan/lab/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        this.$emit("onSave");
        this.hideModal();
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.init();
        }, 1000);
      }
    },

    fetchLab: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/pemeriksaan/lab?no_rawat=${this["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        self.lab = [];
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.nama = item.periksalab.nama;
            item.kode = item.periksalab.kode;
            item.id_ralan_lab = item.id;
            item.id = item.periksalab.id;
            // if(!self.formSet["id_petugas_lab"]){
            //   this.formSet.id_petugas_lab = item.id_petugas;
            // }
            if (item.status != "DIBATALKAN") {
              self.lab = self.lab.concat(item);
            }
          });
          if (result.data.data.length) {
            //console.log(result.data);
            self.getPetugasKategori(result.data.data[0].id_ralan_lab);
          }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    getPetugasKategori: async function(id) {
      let result = await this.$store.state.HTTP.get(
        `ralan/pemeriksaan/lab/${id}`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log(result.data);
        this.formSet.id_petugas_lab = result.data.id_petugas;
        let data_petugas =
          result.data.rln_periksa_lab_petugas ||
          result.data.rnp_periksa_lab_petugas;
        if (data_petugas) {
          this.formSet.petugas_lab = data_petugas.nama;
        }
        this.formSet.lab_type = result.data.kategori;
      } else {
        //console.log('gagal');
      }
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          let nurses = result.data.data.map((item) => {
            return { value: item.id, label: item.nama };
          });
          this.tindakanForm[0].columns[0].options = nurses;
          this.labForm[0].columns[0].options = nurses;
          if (!this.petugas_lab) {
            this.petugas_lab = this.$store.state.petugas_lab || "";
            if (this.petugas_lab) {
              this.labForm[0].columns[0].value = this.petugas_lab;
            }
          }
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      ////console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "lab") {
        url = "periksalab";
      } else {
        url = "tindakan";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            if (type == "lab") {
              item.biaya =
                self.formSet.lab_type == "Dewasa"
                  ? item.biaya_dewasa
                  : item.biaya_anak;
            }
            item.formatted_biaya = convertToRupiah(item.biaya);
            return item;
          });
          ////console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        this[type].push(item);
        this.changed = true;
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
    },
    undoCancel: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = false;
          item.status = item.old_status;
        }
        return item;
      });
    },
    cancelItem: async function(type, id) {
      this.changed = true;
      this.hasCanceled = true;
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
          item.old_status = item.status;
          item.status = "DIBATALKAN";
        }
        return item;
      });
      //console.log(this[type]);
      ////console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
    init: async function() {
      try {
        let result = await this.$store.state.HTTP.get(`ralan/${this.id_ralan}`);
        //console.log(result);
        if (result.status == "200") {
          this.detailTop = setBayarIntro(result.data);
          this["no_rawat"] = result.data.no_rawat;
          this.formSet["id_dokter"] = String(result.data.dokter.id);
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
      this.fetchNurses();
      this.fetchLab();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.init();
  },
};
</script>
